export const VideoPlayer = ({ src, poster, className = "", testId }) => (
  <video
    src={src}
    poster={poster}
    controls
    preload="none"
    playsInline
    className={className}
    data-testid={testId || "video-player"}
  />
);
